import ClientRepository from "@domain/repositories/ClientRepository";
import UseCase from "@domain/UseCase";
import { Client } from "@domain/models/Client";

type Input = Client["id"];

type Output = void;

export class ToggleSpecialIconUseCase implements UseCase<Input, Output> {
  constructor(private readonly clientRepository: ClientRepository) {}

  execute(clientId: Input) {
    return this.clientRepository.toggleSpecialIcon(clientId);
  }
}
